import React, { Component } from 'react';
import Layout from '../../Layouts/DefaultLayout';
import { Container, FormControl, Row, Col, Button, InputGroup, Badge } from "react-bootstrap";
import { PostGrid } from '../../Components';
import * as PostActions from '../../../redux/post/actions';
import Select from 'react-select';

var _ = require('lodash');

class SearchViewContainer extends Component {

    constructor(props) {
        super();
        this.state = {
            selectedtags: [],
            bmos: [],
            posttypes: [],
            searchtxt: "",
            result: null,
            isLoading_posts: false
        }
    }

    componentDidMount = async () => {
        // console.log(this.props);
        // console.log(this.props.location.search);
        this._initiateSearch();

    }


    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }

    _removeSelectedTags = (val) => {
        let arr = this.state.selectedtags;
        arr = _.pull(arr, val);
        this.setState({ selectedtags: arr }, () => this._redirectSearch());
    }
    _removeSelectedBMOS = (val) => {
        let arr = this.state.bmos;
        arr = _.pull(arr, val);
        this.setState({ bmos: arr }, () => this._redirectSearch());
    }
    _removeSelectedPostTypes = (val) => {
        let arr = this.state.posttypes;
        arr = _.pull(arr, val);
        this.setState({ posttypes: arr }, () => this._redirectSearch());
    }

    _convertBMOS = (ar) => {
        let ardata = [];
        if (ar !== null) {
            ar.forEach(function (entry) {
                ardata.push({
                    value: entry.node.slug, label: entry.node.name
                });
            });
        }
        return ardata;
    }
    _convertTags = (ar) => {
        let ardata = [];
        if (ar !== null) {
            ar.forEach(function (entry) {
                ardata.push({
                    value: entry.node.slug, label: entry.node.name
                });
            });
        }
        return ardata;
    }

    _redirectSearch = () => {
        const arr = this.state.selectedtags;
        let para = (this.state.searchtxt !== "") ? `?q=${this.state.searchtxt}` : "";
        const arrbmos = this.state.bmos;
        const arrposttypes = this.state.posttypes;

        if (arr.length > 0) {
            if (para !== "") {
                para += "&";
            } else {
                para += "?";
            }
            para += `tag=${_.join(arr, ",")}`;
        } if (arrbmos.length > 0) {
            if (para !== "") {
                para += "&";
            } else {
                para += "?";
            }
            para += `operator=${_.join(arrbmos, ",")}`;
        } if (arrposttypes.length > 0) {
            if (para !== "") {
                para += "&";
            } else {
                para += "?";
            }
            para += `posts=${_.join(arrposttypes, ",")}`;
        }


        this._dosearch(1);
        this.props.history.push(`/search${para}`);
    }


    _initiateSearch = () => {
        const params = new URLSearchParams(this.props.location.search);
        const q = (params.get("q") !== null ? params.get("q") : "");
        const tags = (params.get("tag") !== null ? _.split(params.get("tag"), ",") : []);
        const bmos = (params.get("operator") !== null ? _.split(params.get("operator"), ",") : []);
        const poststyps = (params.get("posts") !== null ? _.split(params.get("posts"), ",") : []);

        console.log(q, poststyps);
        this.setState({
            searchtxt: q,
            selectedtags: tags,
            bmos: bmos,
            posttypes: poststyps
        }, () => this._dosearch(1));
    }
    _dosearch = async (page) => {
        const tags = this.state.selectedtags;
        const searchtxt = this.state.searchtxt;
        const bmos = this.state.bmos;
        const posttypes = this.state.posttypes;


       // if (tags.length > 0 || searchtxt !== "" || bmos.length > 0 || posttypes.length > 0) {
            const formdata = {
                "env": process.env.REACT_APP_MODE,
                "post-type": ["post", "offering","partner"],
                "posts_per_page": 8,
            };

            if (tags.length > 0) {
                formdata["tag_slug_in"] = tags;
            } if (searchtxt !== "") {
                formdata["search"] = searchtxt;
            } if (bmos.length > 0) {
                formdata["bmos_slugs"] = bmos;
            } if (posttypes.length > 0) {
               const ar_posttypes= _.map(posttypes, function(a) {
                    return a === 'resource' ? 'post' : a;
                  });
                formdata["post-type"] = ar_posttypes;
            }

            console.log(formdata)
            const data = await PostActions.getAnyPostsJSON(this.props.token, page, formdata);
            if (data.status) {
                this.setState({
                    result: data.data
                })
                console.log(data.data);
            } else {
                console.log(data);
            }
       // }
    }

    onPageChange = (page) => {
        console.log(page);
        this._dosearch(page)
    }

    render = () => {
        return (
            <Layout>
                <div className="header-bg p-4">
                    <Container>
                        <h1>Search</h1>
                    </Container>
                </div>
                <Container>
                    <Row className="py-3">
                        <Col md={3}>
                            <div className="form-group">
                                <label >Search by keyword</label>
                                <InputGroup className="mb-3">
                                    <FormControl
                                        placeholder="Enter Search Keyword"
                                        aria-describedby="basic-addon2"
                                        value={this.state.searchtxt}
                                        onKeyPress={(e)=>{ if (e.key === 'Enter') { this._redirectSearch()} }}
                                        onChange={(e) => this.setState({ searchtxt: e.target.value })}
                                    />
                                    <InputGroup.Append>
                                        <Button onClick={() => this._redirectSearch()}><i className="icon-search"></i></Button>
                                    </InputGroup.Append>
                                </InputGroup>
                            </div>
                        </Col>
                        <Col md={3}>
                            {this._renderSelectBMO()}
                        </Col>
                        <Col md={3}>
                           {this._renderSelectTags()}
                        </Col>
                        <Col md={3}>
                            {this._renderSelectPostTypes()}
                        </Col>
                    </Row>
                    {(this.state.result !== null) && (
                        <Row>
                            <Col md={12}>
                                <PostGrid
                                    data={this.state.result.data ? this.state.result.data : []}
                                    currentpage={parseInt(this.state.result.currentpage)}
                                    max_num_pages={parseInt(this.state.result.max_num_pages)}
                                    isLoading={this.state.isLoading_posts}
                                    onPageChange={this.onPageChange}
                                    multiple_posttype={true}
                                />
                            </Col>
                        </Row>
                    )}


                </Container>
            </Layout>
        );
    };


    array_addOrRemove = (arr, val) => {
        if (!_.includes(arr, val)) {
            arr.push(val);
        } else {
            _.remove(arr, item => item === val);
        }
        return arr;
    }

    handleOnChange = (e, typ) => {
        if (typ === "bmos") {
            const val = (e !== null ? e.map(obj => obj.value) : []);
            let rm = _.uniq(val);
            this.setState({ bmos: rm }
                , () => this._redirectSearch()
            );
        }else if (typ === "tags") {
            const val = (e !== null ? e.map(obj => obj.value) : []);
            let rm = _.uniq(val);
            this.setState({ selectedtags: rm }
                , () => this._redirectSearch()
            );
        }else if(typ==="postypes"){
            const val = (e !== null ? e.map(obj => obj.value) : []);
            let rm = _.uniq(val);
            console.log(rm);
            this.setState({ posttypes: rm }
                , () => this._redirectSearch()
            );
        }
    }

    _renderSelectBMO = () => {
        let arSelectedbmos = this.state.bmos;
        //console.log(arSelectedbmos);
        let arallbmos = this._convertBMOS(this.props.bmos);
        return (
            <div className="form-group">
                <label >Filter By Operators</label>
                <Select isMulti options={arallbmos}
                    value={arallbmos.filter(f => arSelectedbmos.includes(f.value))}
                    onChange={(e) => this.handleOnChange(e, "bmos")}
                />
            </div>
        );
    }
    _renderSelectTags = () => {
        let arSelectedtags = this.state.selectedtags;
       // console.log(arSelectedtags);
        let aralltags = this._convertTags(this.props.tags);
        return (
            <div className="form-group">
                <label >Filter By Tags</label>
                <Select isMulti options={aralltags}
                    value={aralltags.filter(f => arSelectedtags.includes(f.value))}
                    onChange={(e) => this.handleOnChange(e, "tags")}
                />
            </div>
        );
    }
    _renderSelectPostTypes = () => {
        let arSelectedpostTypes = this.state.posttypes;
        let arAllPostTypes =[{value:'offering',label:"Offerings"},{value:'resource',label:"Resources"}];
        return (
            <div className="form-group">
                <label >Filter By Post type</label>
                <Select isMulti options={arAllPostTypes}
                    value={arAllPostTypes.filter(f => arSelectedpostTypes.includes(f.value))}
                    onChange={(e) => this.handleOnChange(e, "postypes")}
                />
            </div>
        );
    }

    _renderTags = () => {
        let tags = this.state.selectedtags;
        return (
            <React.Fragment>
                {(tags.length > 0) &&
                    (
                        <React.Fragment>
                            {`Filter by Tag${tags.length > 1 ? "s" : ""}: `}
                            {tags.map(function (object, i) {
                                return <Badge key={`badge${object}`} onClick={() => this._removeSelectedTags(object)} className="search-tag" variant="primary">{`# ${object}    `}<i className="icon-search"></i></Badge>;
                            }.bind(this))}
                        </React.Fragment>
                    )

                }

            </React.Fragment>
        );
    }
    _renderBMOS = () => {
        let bmos = this.state.bmos;
        return (
            <React.Fragment>
                {(bmos.length > 0) &&
                    (
                        <React.Fragment>
                            {`Filter by Operator${bmos.length > 1 ? "s" : ""}: `}
                            {bmos.map(function (object, i) {
                                return <Badge key={`badge${object}`} onClick={() => this._removeSelectedBMOS(object)} className="search-tag" variant="primary">{`# ${object}    `}<i className="icon-search"></i></Badge>;
                            }.bind(this))}
                        </React.Fragment>
                    )
                }

            </React.Fragment>
        );
    }

    _renderPostTypes = () => {
        let posttypes = this.state.posttypes;
        return (
            <React.Fragment>
                {(posttypes.length > 0) &&
                    (
                        <React.Fragment>
                            {`Filter by: `}
                            {posttypes.map(function (object, i) {
                                return <Badge key={`badge${object}`} onClick={() => this._removeSelectedPostTypes(object)} className="search-tag" variant="primary">{`# ${object}    `}<i className="icon-search"></i></Badge>;
                            }.bind(this))}
                        </React.Fragment>
                    )
                }

            </React.Fragment>
        );
    }

}


/* Export Component ==================================================================== */
export default SearchViewContainer;